import firebase from 'firebase/app';
import 'firebase/auth';

// Kept out of ./firebase.js so the auth module can import it without creating a
// circular import (firebase.js -> module/auth -> action/auth -> firebase.js)
let chatSignIn = Promise.resolve();

// Firestore rules allow chat access by request.auth.uid (= userInfo.id), so sign in with the backend's custom token
export function signInChatUser(tokenPromise) {
  chatSignIn = tokenPromise
    .then((token) => token && firebase.auth().signInWithCustomToken(token))
    .catch((e) => console.log('signInChatUser error: ', e));
}

export function signOutChatUser() {
  return firebase.auth().signOut();
}

export function waitChatSignIn() {
  return chatSignIn;
}
